import React, { useState } from 'react'
import Pulse from '../Loader/Pulse';
import { COLOR_VARS } from '../../exports/ColorVars';
import { OrderBook } from '../CustomComponents/SwiftIcon/Icons';
import "../../css/MFManagement/MFManagement.css"

const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

const MFTransctions = () => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [userRole, setUserRole] = useState(false);

    return (
        <div className="orders-wrapper full">
            <div className='table-container'>
                {loading === true ? <>
                    <div className="table-loader">
                        <Pulse />
                        <p>Fetching your transactions...</p>
                    </div>
                </> : <>
                {transactions.length > 0 ?
                <>
                
                </>:
                <div className='order-container-empty'>
                            <OrderBook size={40} color={COLOR_VARS['SWIFT_COLOR4']}  />
                            <div>
                                <p>No transactions found</p>
                                <span>Looks like you have't made any transactions today</span>
                            </div>
                        </div>  
            }
                </>
                }
            </div>
        </div>
    )
}

export default MFTransctions
